'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _components = require('./../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _auth = require('../../redux/modules/auth');

var _QRLogin = require('./QRLogin.scss');

var _QRLogin2 = _interopRequireDefault(_QRLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logo = require('../../../res/images/logo/stingray_logo_horizontal_white.svg');

var QRLogin = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth, sessionId: state.auth.sessionId };
}, { login: _auth.login, pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(QRLogin, _Component);

  function QRLogin() {
    (0, _classCallCheck3.default)(this, QRLogin);
    return (0, _possibleConstructorReturn3.default)(this, (QRLogin.__proto__ || (0, _getPrototypeOf2.default)(QRLogin)).apply(this, arguments));
  }

  (0, _createClass3.default)(QRLogin, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _QRLogin2.default.qrLoginPage },
        _react2.default.createElement(_reactHelmet2.default, { title: 'QRLogin' }),
        _react2.default.createElement(
          'h1',
          { className: _QRLogin2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.QRLogin)
        ),
        _react2.default.createElement(_components.QRSteps, { step1StingId: _DefaultString.translations.QRLoginStep1 }),
        _react2.default.createElement(
          'div',
          { className: _QRLogin2.default.endContainer },
          _react2.default.createElement(_components.RememberMe, { className: _QRLogin2.default.rememberMe }),
          _react2.default.createElement(
            'div',
            { className: _QRLogin2.default.logo },
            _react2.default.createElement('img', { src: logo })
          )
        )
      );
    }
  }]);
  return QRLogin;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired,
  sessionId: _react.PropTypes.string
}, _temp)) || _class);
exports.default = QRLogin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/QRLogin/QRLogin.js
// module id = 2015
// module chunks = 0